import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PaymentFailPageRoutingModule } from './payment-fail-routing.module';

import { PaymentFailPage } from './payment-fail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PaymentFailPageRoutingModule
  ],
  declarations: [PaymentFailPage]
})
export class PaymentFailPageModule {}
